var map = {
	"./HoroscopeSigns/aquarius.svg": [
		9595,
		9595
	],
	"./HoroscopeSigns/aries.svg": [
		1331,
		1331
	],
	"./HoroscopeSigns/cancer.svg": [
		768,
		768
	],
	"./HoroscopeSigns/capricorn.svg": [
		7408,
		7408
	],
	"./HoroscopeSigns/default.svg": [
		3190,
		3190
	],
	"./HoroscopeSigns/gemini.svg": [
		5316,
		5316
	],
	"./HoroscopeSigns/leo.svg": [
		282,
		282
	],
	"./HoroscopeSigns/libra.svg": [
		5409,
		5409
	],
	"./HoroscopeSigns/pisces.svg": [
		8498,
		8498
	],
	"./HoroscopeSigns/sagitarrius.svg": [
		4548,
		4548
	],
	"./HoroscopeSigns/scorpio.svg": [
		1018,
		1018
	],
	"./HoroscopeSigns/taurus.svg": [
		741,
		741
	],
	"./HoroscopeSigns/virgo.svg": [
		6143,
		6143
	],
	"./RatingStars/fiveRatingStars.svg": [
		1679,
		1679
	],
	"./RatingStars/outlineStar.svg": [
		2917,
		2917
	],
	"./RatingStars/ratingHalfStar.svg": [
		9140,
		9140
	],
	"./RatingStars/ratingStar.svg": [
		625,
		625
	],
	"./account-icon.svg": [
		633,
		633
	],
	"./alertOff.svg": [
		1120,
		1120
	],
	"./alertOn.svg": [
		78,
		78
	],
	"./androidApp.svg": [
		1359,
		1359
	],
	"./appleApp.svg": [
		6985,
		6985
	],
	"./burgerMenu.svg": [
		8289,
		8289
	],
	"./catAstrologyAdvice.svg": [
		3093,
		3093
	],
	"./catFinancialOutlook.svg": [
		963,
		963
	],
	"./catLifeQuestions.svg": [
		1353,
		1353
	],
	"./catLoveAndRelationships.svg": [
		8739,
		8739
	],
	"./catPsychicMediums.svg": [
		5742,
		5742
	],
	"./catReadingGlobe.svg": [
		9452,
		9452
	],
	"./catSpiritualReadings.svg": [
		7072,
		7072
	],
	"./catTarotReadings.svg": [
		8450,
		8450
	],
	"./error-500.svg": [
		9220,
		9220
	],
	"./fa-brands/facebook-square.svg": [
		5823,
		5823
	],
	"./fa-brands/instagram.svg": [
		8009,
		8009
	],
	"./fa-brands/pinterest-square.svg": [
		2015,
		2015
	],
	"./fa-brands/twitter-square.svg": [
		6260,
		6260
	],
	"./facebook.svg": [
		370,
		370
	],
	"./headerAccountLogOut.svg": [
		1963,
		1963
	],
	"./headerAccountSettings.svg": [
		8547,
		8547
	],
	"./histogram.svg": [
		8335,
		8335
	],
	"./instagram.svg": [
		9009,
		9009
	],
	"./keenLogoDefault.svg": [
		8452,
		8452
	],
	"./keenLogoIcon.svg": [
		9054,
		9054
	],
	"./keenLogoRibbon.svg": [
		7125,
		7125
	],
	"./keenLogoText.svg": [
		5781,
		5781
	],
	"./pinterest.svg": [
		3804,
		3804
	],
	"./readingGlobe.svg": [
		1339,
		1339
	],
	"./scrollTop.svg": [
		5495,
		5495
	],
	"./search-icon.svg": [
		1706,
		1706
	],
	"./tryBestMatch.svg": [
		7197,
		7197
	],
	"./twitter.svg": [
		2402,
		2402
	],
	"./twoCircles.svg": [
		498,
		498
	],
	"./upArrowNav.svg": [
		7039,
		7039
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8280;
module.exports = webpackAsyncContext;